import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import Zone from "@insite/client-framework/Components/Zone";
import PageModule from "@insite/client-framework/Types/PageModule";
import PageProps from "@insite/client-framework/Types/PageProps";
import Page, { PageProps as MobiusPageProps } from "@insite/mobius/Page";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import * as React from "react";
import { css } from "styled-components";

export interface FooterStyles {
    page?: MobiusPageProps;
    columnsWrapper?: InjectableCss;
    copy?: InjectableCss;
}

export const footerStyles: FooterStyles = {
    page: {
        css: css`
            background-color: #1A1A1A;
            padding: 0 !important;
            max-width: inherit !important;            
        `,
    },
    columnsWrapper: {
        css: css`
            display: grid;
            grid-template-columns: repeat(5, 1fr);
            gap: 24px;
            width: 100%;
            padding: 47px 40px;
            margin: 0 auto;

            @media (max-width: 768px) {
                grid-template-columns: 1fr;
                gap: 16px;
                padding: 47px 20px;
            }

            @media (min-width: 576px) {
                max-width: 540px;
            }

            @media (min-width: 768px) {
                max-width: 720px;
            }

            @media (min-width: 1200px) {
                max-width: 1260px;
            }

            @media (min-width: 1600px) {
                max-width: 1540px;
            }

            img {
                width: 98px;
                height: 30px;
                margin-bottom: 16px;
            }

            h6 {
                color: ${({ theme }) => theme.colors.common.border};
                font-weight: 300;
                margin-bottom: 11px !important;
            }

            p {
                color: ${({ theme }) => theme.colors.common.disabled};
                font-size: 12px;
                margin-bottom: 20px !important;
            }

            .social-links{
                padding: 0;
                gap: 12px;

                .link-wrapper {
                    padding: 0;
                    margin: 0;
                    flex-grow: inherit;

                    .social-link {
                        background-color: ${({ theme }) => theme.colors.secondary.contrast};
                        width: 32px;
                        height: 32px;
                        display: flex;
                        align-items: center;
                        justify-content: center;

                        &:hover {
                            opacity: 0.75;
                        }

                        [class^="IconWrapper-sc-"] {
                            width: auto;
                            height: auto;
                            margin: 0;

                            svg {
                                color: ${({ theme }) => theme.colors.common.border};
                                width: 16px;
                                height: 16px;
                            }
                        }
                    }
                }
            }

            h3 {
                font-size: 14px;
                color: ${({ theme }) => theme.colors.primary.contrast};
                background-color: transparent;
                padding: 0;
                margin-bottom: 16px !important;
            }

            a {
            
                &.link {
                    font-size: 12px;
                    margin-bottom: 8px;

                    &:hover {

                        span {
                            color: ${({ theme }) => theme.colors.common.border};
                            text-decoration: underline;
                        }
                    }

                    span {
                        color: ${({ theme }) => theme.colors.common.border};
                    }
                }
            }
        `,
    },
    copy: {
        css: css`
            color: ${({ theme }) => theme.colors.common.disabled};
            border-top: ${({ theme }) => theme.colors.text.main} solid 1px;
            padding: 16px 40px;

            @media (max-width: 768px) {
                padding: 16px 20px;
            }

            span {
                color: ${({ theme }) => theme.colors.common.disabled};
            }

            .list-wrapper{
                text-align: right;
                padding: 0;

                @media (max-width: 768px) {
                    text-align: left;
                    margin-top: 40px;
                }

                .links-wrapper{
                
                    a{

                        &:hover {
                            text-decoration: underline;
                        }

                        span {
                            font-size: 12px;
                            color: ${({ theme }) => theme.colors.common.disabled};
                            text-transform: initial;
                            padding: 0 8px 0 0;
                        }
                    }
                }
            }
        `
    }
};

const styles = footerStyles;

const Footer = ({ id }: PageProps) => (
    <Page as="footer" isFooter={true} {...styles.page}>
        <StyledWrapper {...styles.columnsWrapper}>
            <Zone contentId={id} zoneName="FooterCol1" />
            <Zone contentId={id} zoneName="FooterCol2" />
            <Zone contentId={id} zoneName="FooterCol3" />
            <Zone contentId={id} zoneName="FooterCol4" />
            <Zone contentId={id} zoneName="FooterCol5" />
        </StyledWrapper>
        <StyledWrapper {...styles.copy}>
            <Zone contentId={id} zoneName="Copy" />
        </StyledWrapper>
    </Page>
);

const pageModule: PageModule = {
    component: Footer,
    definition: {
        hasEditableTitle: false,
        hasEditableUrlSegment: false,
        pageType: "System",
    },
};

export default pageModule;

/**
 * @deprecated Use string literal "Footer" instead of this constant.
 */
export const FooterContext = "Footer";